module.exports = __webpack_public_path__ + "static/img/szafa_6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/_kopia/szafa_6.jpg
// module id = y0QR
// module chunks = 0